module.exports = __webpack_public_path__ + "static/media/machine5.24aa6074.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/machine5.png
// module id = 866
// module chunks = 0